import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getExceptions = async () => {
  const response = await axios.get(`${getAPIService}/v2/api/cron-tasks/context_exceptions`)
  return response.data
}
